import { styled } from '@material-ui/core/styles';

export const AppContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
}));

export const VerticalContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

// Not using 'main' tag here as it is not supported by IE11.
export const PageContainer = styled('div')({});
